import styled from "styled-components";
import { primaryButtonBase } from "../styles/buttonStyles";
import { colors } from "../styles/designSystem";

export const Row = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 1rem;
        margin-bottom: 1rem;
    }
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const Label = styled.label`
    font-size: 0.9rem;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
`;

export const Input = styled.input`
    padding: 0.75rem;
    border: 1px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'};
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    font-size: 1rem;
    font-family: inherit;
    transition: border-color 0.2s ease;
    width: 100%;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary};
    }

    &::placeholder {
        color: ${({ theme }) => theme.subtleText};
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        font-size: 0.95rem;
        padding: 0.65rem;
    }
`;

export const Select = styled.select`
    padding: 0.75rem;
    border: 1px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'};
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    font-size: 1rem;
    font-family: inherit;
    cursor: pointer;
    transition: border-color 0.2s ease;
    width: 100%;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary};
    }

    @media (max-width: 768px) {
        font-size: 0.95rem;
        padding: 0.65rem;
    }
`;

export const TextArea = styled.textarea`
    padding: 0.75rem;
    border: 1px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'};
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    font-size: 1rem;
    font-family: inherit;
    resize: vertical;
    transition: border-color 0.2s ease;
    width: 100%;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primary};
    }

    &::placeholder {
        color: ${({ theme }) => theme.subtleText};
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        font-size: 0.95rem;
        padding: 0.65rem;
    }
`;

export const CheckboxRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin: 1.5rem 0;

    input[type="checkbox"] {
        margin-top: 0.25rem;
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
    }

    label {
        font-size: 0.9rem;
        line-height: 1.5;
        color: ${({ theme }) => theme.text};
        cursor: pointer;
    }

    @media (max-width: 768px) {
        margin: 1rem 0;

        label {
            font-size: 0.85rem;
        }
    }
`;

export const Helper = styled.p`
    font-size: 0.85rem;
    color: ${({ theme }) => theme.subtleText};
    margin: 0 0 1.5rem;
    line-height: 1.5;

    a {
        color: ${({ theme }) => theme.primary};
        text-decoration: underline;

        &:hover {
            filter: brightness(1.2);
        }
    }

    @media (max-width: 768px) {
        font-size: 0.8rem;
        margin-bottom: 1rem;
    }
`;

export const Submit = styled.button`
    ${primaryButtonBase}
    padding: 0.75rem 2rem;

    @media (max-width: 768px) {
        width: 100%;
        padding: 0.65rem 1.5rem;
    }
`;

export const StatusMessage = styled.div.attrs(({ type }) => ({
    role: type === "error" ? "alert" : "status",
    'aria-live': "polite",
    'aria-atomic': "true"
}))`
    padding: 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
    line-height: 1.5;

    background: ${({ type }) =>
        type === "success" ? "rgba(0, 233, 107, 0.12)" : "rgba(230, 39, 24, 0.12)"};

    border: 1px solid ${({ type }) => (type === "success" ? colors.emerald[500] : colors.red[400])};
    color: ${({ type }) => (type === "success" ? colors.emerald[300] : colors.red[200])};

    &::before {
        content: ${({ type }) => (type === "success" ? '"> OK: "' : '"> ERR: "')};
        opacity: 0.7;
    }

    @media (max-width: 768px) {
        font-size: 0.9rem;
        padding: 0.85rem;
    }
`;